import { render, staticRenderFns } from "./sub-history.vue?vue&type=template&id=c2214dd8&scoped=true"
import script from "./sub-history.vue?vue&type=script&lang=js"
export * from "./sub-history.vue?vue&type=script&lang=js"
import style0 from "./sub-history.vue?vue&type=style&index=0&id=c2214dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2214dd8",
  null
  
)

export default component.exports